const UsageTypeReviewIcon = ({ size = 56, className = "", isActive = false, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Background */}
      <circle
        cx="28"
        cy="28"
        r="27"
        fill={isActive ? "#68D7FF" : "#9EA6B2"}
        fillOpacity={isActive ? 0.2 : 0.3}
        stroke={`url(#${isActive ? "blueGradient" : "whiteGradient"})`}
        strokeWidth="2"
      />

      {/* Main icon paths - kept identical for both */}
      <path
        d="M38.5463 23.5838C38.0755 23.0698 37.3271 23.0375 36.8211 23.4874C36.7479 23.5525 36.8046 23.4951 35.6902 24.7107L38.5827 27.8662L39.6223 26.7463C40.1249 26.198 40.1249 25.3059 39.6223 24.7576L38.5463 23.5838Z"
        fill={isActive ? "#01BBFE" : "white"}
      />
      <path
        d="M29.7587 31.2413L28.0572 35.2188C27.9426 35.4868 27.9939 35.8043 28.1855 36.0134C28.3771 36.2225 28.6683 36.2784 28.9138 36.1533L32.5599 34.2971C32.7041 34.2237 32.2674 34.6696 37.6655 28.8543L34.7788 25.705C29.4267 31.5437 29.8273 31.0809 29.7587 31.2413Z"
        fill={isActive ? "#01BBFE" : "white"}
      />
      <path
        d="M33.646 35.1611C33.4881 35.3312 33.3062 35.4692 33.1052 35.5715L29.4591 37.4277C28.7421 37.7927 27.8662 37.6538 27.2742 37.0078C26.7014 36.383 26.5467 35.4251 26.8892 34.6242L28.5908 30.6466C28.6863 30.4232 28.8158 30.2215 28.9756 30.0472L34.457 24.0675V18.1094C34.457 16.9463 33.5896 16 32.5234 16H19.9336C18.8674 16 18 16.9463 18 18.1094V37.8906C18 39.0537 18.8674 40 19.9336 40H32.5234C33.5896 40 34.457 39.0537 34.457 37.8906V34.2873L33.646 35.1611ZM21.4375 20.5469H31.0625C31.4185 20.5469 31.7071 20.8617 31.7071 21.25C31.7071 21.6383 31.4185 21.9531 31.0625 21.9531H21.4375C21.0816 21.9531 20.793 21.6383 20.793 21.25C20.793 20.8617 21.0816 20.5469 21.4375 20.5469ZM21.4375 24.2969H29C29.356 24.2969 29.6446 24.6117 29.6446 25C29.6446 25.3883 29.356 25.7031 29 25.7031H21.4375C21.0816 25.7031 20.793 25.3883 20.793 25C20.793 24.6117 21.0816 24.2969 21.4375 24.2969ZM20.793 28.75C20.793 28.3617 21.0816 28.0469 21.4375 28.0469H26.9375C27.2935 28.0469 27.5821 28.3617 27.5821 28.75C27.5821 29.1383 27.2935 29.4531 26.9375 29.4531H21.4375C21.0816 29.4531 20.793 29.1383 20.793 28.75Z"
        fill={isActive ? "#01BBFE" : "white"}
      />

      {/* Gradients */}
      <defs>
        <linearGradient id="whiteGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="blueGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#68D7FF" />
          <stop offset="1" stopColor="#68D7FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default UsageTypeReviewIcon;
